import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const ThirdPartyFulfillmentBudget = z.object({
  sourceTeamId: z.string(),
  warehouseAccountId: z.string(),
  name: z.string(),
  timezone: z.string().nullable(),
  configurationError: z.string().nullable(),
  enabled: z.boolean(),
  limits: z.array(z.number().nullable()),
  revision: z.string(),
  count: z.number(),
  limit: z.number().nullable(),
  date: z.string().nullable(),
  paused: z.boolean(),
});
export type ThirdPartyFulfillmentBudget = z.infer<
  typeof ThirdPartyFulfillmentBudget
>;

export const getThirdPartyFulfillmentBudgets = unaryRpc({
  name: "getThirdPartyFulfillmentBudgets" as const,
  input: z.object({ merchantTeamId: zExt.objectId() }),
  output: z.object({ warehouses: z.array(ThirdPartyFulfillmentBudget) }),
});
